<template>
  <div>
    <loader />
    <div class="page-wrapper">
      <Header />
      <!-- End .header -->

      <main class="main home">
        <nav
          v-if="
            route.name !== 'Home'
            && route.name !== 'Category'
            && route.name !== 'Article'
            && route.name !== 'Blog'
            && route.name !== 'Brand'
          "
          class="breadcrumb-nav"
        >
          <div class="container">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">
                  <i class="icon-home" />
                </router-link>
              </li>
              <li class="breadcrumb-item active">{{ route.meta.title }}</li>
            </ol>
          </div>
        </nav>
        <nav class="breadcrumb-nav" v-if="route.name === 'Category'">
          <div class="container">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">
                  <i class="icon-home" />
                </router-link>
              </li>
              <li
                class="breadcrumb-item"
                v-for="item in parentCategories"
                :key="item.id"
              >
                <router-link
                  :to="{ name: 'Category', params: {
                      id: item.id,
                      slug: item.slug,
                    }
                  }"
                >
                  {{ item?.title }}
                </router-link>
              </li>
              <li class="breadcrumb-item active">{{ category?.title }}</li>
            </ol>
          </div>
        </nav>
        <nav class="breadcrumb-nav" v-if="route.name === 'Article'">
          <div class="container">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">
                  <i class="icon-home" />
                </router-link>
              </li>
              <li class="breadcrumb-item" v-for="cat in articleParentCategories" :key="cat.id">
                <router-link
                  :to="{ name: 'Category',
                    params: {
                      id: cat.id,
                      slug: slugify(cat.title)
                    }
                  }"
                >
                  {{ cat.title }}
                </router-link>
              </li>
              <li class="breadcrumb-item active">{{ article.title }}</li>
            </ol>
          </div>
        </nav>
        <nav class="breadcrumb-nav" v-if="route.name === 'Blog'">
          <div class="container">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">
                  <i class="icon-home" />
                </router-link>
              </li>
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Blogs' }">
                  Vijesti
                </router-link>
              </li>
              <li class="breadcrumb-item active">{{ blog.title }}</li>
            </ol>
          </div>
        </nav>
        <nav class="breadcrumb-nav" v-if="route.name === 'Brand'">
          <div class="container">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">
                  <i class="icon-home" />
                </router-link>
              </li>
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Brands' }">
                  {{ translations.brands }}
                </router-link>
              </li>
              <li class="breadcrumb-item active">{{ brandSearchFilter.brands?.[0]?.title }}</li>
            </ol>
          </div>
        </nav>
        <router-view :key="$route.path" />
      </main>
      <!-- End .main -->

      <Footer />
      <!-- End .footer -->
    </div>
    <!-- End .page-wrapper -->

    <div class="mobile-menu-overlay"></div>
    <!-- End .mobil-menu-overlay -->

    <div class="mobile-menu-container">
      <div class="mobile-menu-wrapper">
        <span class="mobile-menu-close"><i class="icon-retweet"></i></span>
        <nav class="mobile-nav">
          <ul class="mobile-menu" @click.capture="handleMobileMenuClick">
            <router-link
              :to="{ name: 'Home' }"
              v-slot="{ href, isExactActive, navigate }"
              custom
            >
              <li :class="{ 'active': isExactActive }">
                <a :href="href" @click="navigate">
                  {{ translations.homePageTitle }}
                </a>
              </li>
            </router-link>
            <li>
              <a href="#">{{ translations.categories }}</a>
              <ul>
                <li v-for="item in treeViewCategories" :key="item.id">
                  <router-link :to="{ name: 'Category', params: { id: item.id, slug: item.slug } }">
                    {{ item.label }}
                  </router-link>

                  <ul v-if="item.children && item.children.length > 0">
                    <li v-for="sub in item.children" :key="sub.id" class="pl-4">
                      <router-link
                        :to="{ name: 'Category', params: { id: sub.id, slug: sub.slug } }"
                      >
                        <span>{{ sub.label }}</span>
                        <span class="pl-2">({{ getNumberOfArticles(sub) }})</span>
                      </router-link>

                      <ul v-if="sub.children && sub.children.length > 0">
                        <li v-for="subSub in sub.children" :key="subSub.id" class="pl-4">
                          <router-link
                            :to="{ name: 'Category', params: { id: subSub.id, slug: subSub.slug } }"
                          >
                            <span>{{ subSub.label }}</span>
                            <span class="pl-2">({{ getNumberOfArticles(subSub) }})</span>
                          </router-link>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>

            <router-link
              :to="{ name: 'MyArticles' }"
              v-slot="{ href, isExactActive, navigate }"
              custom
            >
              <li :class="{ 'active': isExactActive }">
                <a :href="href" @click="navigate">
                  {{ translations.myArticles }}
                </a>
              </li>
            </router-link>

            <router-link
              :to="{ name: 'Orders' }"
              v-slot="{ href, isExactActive, navigate }"
              custom
            >
              <li :class="{ 'active': isExactActive }">
                <a :href="href" @click="navigate">
                  {{ translations.orders }}
                </a>
              </li>
            </router-link>

            <router-link
              :to="{ name: 'Blogs' }"
              v-slot="{ href, isExactActive, navigate }"
              custom
            >
              <li :class="{ 'active': isExactActive }">
                <a :href="href" @click="navigate">
                  {{ translations.news }}
                </a>
              </li>
            </router-link>

            <router-link
              :to="{ name: 'About' }"
              v-slot="{ href, isExactActive, navigate }"
              custom
            >
              <li :class="{ 'active': isExactActive }">
                <a :href="href" @click="navigate">
                  {{ translations.aboutUs }}
                </a>
              </li>
            </router-link>

            <router-link
              :to="{ name: 'Contact' }"
              v-slot="{ href, isExactActive, navigate }"
              custom
            >
              <li :class="{ 'active': isExactActive }">
                <a :href="href" @click="navigate">
                  {{ translations.contact }}
                </a>
              </li>
            </router-link>

            <li>
              <a href="#">{{ translations.myProfile }}</a>
              <ul>
                <li>
                  <router-link :to="{ name: 'ProfileDashboard' }">
                    {{ translations.myAccount }}
                  </router-link>
                </li>
                <li>
                  <router-link :to="{ name: 'LogOut' }">
                    {{ translations.logout }}
                  </router-link>
                </li>
              </ul>
            </li>
          </ul>
        </nav>
        <!-- End .mobile-nav -->

        <div class="social-icons">
          <a
            href="#"
            class="social-icon"
            target="_blank"
          >
            <i class="fab fa-facebook-f"></i>
          </a>
          <!--
          <a href="#" class="social-icon" target="_blank"><i class="fab fa-twitter"></i></a>
          -->
          <a
            href="#"
            class="social-icon"
            target="_blank"
          >
            <i class="fab fa-linkedin-in"></i>
          </a>
        </div>
        <!-- End .social-icons -->
      </div>
      <!-- End .mobile-menu-wrapper -->
    </div>
    <!-- End .mobile-menu-container -->

    <!-- newsletter-popup-form -->
    <div
      class="newsletter-popup mfp-hide"
      id="newsletter-popup"
      style="background-image: url(assets/images/newsletter_popup_bg.jpg)"
    >
      <div class="newsletter-popup-content">
        <img src="assets/images/logo-black.png" alt="Logo" class="logo-newsletter" />
        <h2>BE THE FIRST TO KNOW</h2>
        <p>
          Subscribe to the Porto eCommerce newsletter to receive timely updates from your favorite
          products.
        </p>
        <form action="#">
          <div class="input-group">
            <input
              type="email"
              class="form-control"
              id="newsletter-email"
              name="newsletter-email"
              placeholder="Email address"
              required
            />
            <input type="submit" class="btn" value="Go!" />
          </div>
          <!-- End .from-group -->
        </form>
        <div class="newsletter-subscribe">
          <div class="checkbox">
            <label>
              <input type="checkbox" value="1" />
              Don't show this popup again
            </label>
          </div>
        </div>
      </div>
      <!-- End .newsletter-popup-content -->
    </div>
    <!-- End .newsletter-popup -->

    <a id="scroll-top" href="#top" title="Top" role="button">
      <i class="icon-angle-up"></i>
    </a>

    <OutOfStockModal />
  </div>
</template>

<script>
// eslint-disable-next-line
import { routes } from '@/router';
import { translations } from '@/mixins';
import slugify from '@/filters/slugify';
import config from '@/config';
// eslint-disable-next-line
import * as signalR from '@microsoft/signalr';
// eslint-disable-next-line
import { HttpTransportType } from '@microsoft/signalr';

import Loader from '@/components/shared/Loader.vue';
import Footer from '@/components/Footer/Footer.vue';
import Header from '@/components/Header/Header.vue';
import OutOfStockModal from '@/components/shared/modal/OutOfStockModal.vue';

export default {
  name: 'MainApp',
  mixins: [translations],
  components: {
    Footer,
    Header,
    Loader,
    OutOfStockModal,
  },
  data() {
    return {
      connection: null,
    };
  },
  mounted() {
    this.$store.dispatch('getCategories', {
      sortBy: 'createdDate',
      isSortAscending: false,
      retrieveAll: true,
    });
    this.$store.dispatch('getProfile').then(() => {
      this.startCartSignalRConnection();
    });
    this.$store.dispatch('getShoppingCart');
    this.$store.dispatch('getAllowOrderingStockZero');
    this.$store.dispatch('getFinanceInfo', { externalCompanyId: this.profile.userData.externalCompanyId });
    Porto.checkMobile();
    // Porto.stickyHeader();
    Porto.headerSearchToggle();
    Porto.mMenuIcons();
    Porto.mMenuToggle();
    Porto.mobileMenu();
    Porto.scrollToTop();
    // Porto.quantityInputs();
    // Porto.tooltip();
    // Porto.popover();
    // Porto.changePassToggle();
    // Porto.changeBillToggle();
    // Porto.catAccordion();
    // Porto.ajaxLoadProduct();
    // Porto.toggleFilter();
    // Porto.toggleSidebar();
    // Porto.productTabSroll();
    // Porto.scrollToElement();
    // Porto.loginPopup();
    // Porto.modalView();
    // Porto.productManage();
    // Porto.ratingTooltip();
    // Porto.isotopes();
    // Porto.windowClick();
    this.startSignalRConnection();
  },
  beforeDestroy() {
    // Stop SignalR connection when component is destroyed
    if (this.connection) {
      this.connection.stop();
      console.log('SignalR Disconnected.');
    }
  },
  computed: {
    route() {
      return this.$route;
    },
    parentRoute() {
      return routes[3].children.find(
        (item) => this.$route.meta.parent && item.name === this.$route.meta.parent,
      );
    },
    profile() {
      return this.$store.getters.getProfile;
    },
    treeViewCategories() {
      return this.$store.getters.getCategoriesTreeView;
    },
    article() {
      return this.$store.getters.getArticle;
    },
    categories() {
      return this.$store.getters.getCategories;
    },
    category() {
      return this.$store.getters.getCategoryById(
        this.route.name === 'Article'
          ? this.article?.categoryIds?.[0]
          : this.$route.params.id,
      );
    },
    articleParentCategories() {
      return this.$store.getters.getArticleParentCategories(this.route.name === 'Article' ? this.article?.categoryIds?.[0] : 0);
    },
    blog() {
      return this.$store.getters.getBlog;
    },
    brandSearchFilter() {
      return this.$store.getters.getSearchFilters;
    },
    parentCategories() {
      const { categories, category } = this;
      const parentCategories = [];

      const findParent = (categoryId) => {
        const parent = categories.find(
          (c) => c.id === categoryId,
        );

        if (parent) {
          parentCategories.push(parent);
          findParent(parent.parentCategoryId);
        }
      };

      findParent(category.parentCategoryId);

      return parentCategories.map(({ id, title, parentCategoryId }) => ({
        id, title, slug: slugify(title), parentCategoryId,
      })).reverse();
    },
  },
  methods: {
    closeMobileMenu() {
      document.body.classList.remove('mmenu-active');
    },
    handleMobileMenuClick(event) {
      if (event.target.closest('.mmenu-btn')) {
        return;
      }

      const link = event.target.closest('a');

      if (!link || link.getAttribute('href') === '#') {
        return;
      }

      this.closeMobileMenu();
    },
    getNumberOfArticles(obj) {
      let count = obj.numberOfArticles || 0; // count the number of articles in the current object
      const { children } = obj;

      if (children) { // if there are child objects, count their articles recursively
        children.forEach((child) => {
          count += this.getNumberOfArticles(child);
        });
      }
      return count;
    },
    async startSignalRConnection() {
      this.connection = new signalR.HubConnectionBuilder()
        .withUrl(`${config.apiSignalR}/notificationHub`, {
          accessTokenFactory: () => localStorage.getItem('token'),
          withCredentials: false,
        })
        .build();
      this.connection.on('NewNotifications', (lastUpdate, notifications) => {
        console.log('New notifications received:', notifications);
        this.$store.dispatch('getUnreadMessagesCount');
        this.$store.dispatch('getMessages');
      });

      try {
        await this.connection.start();
      } catch (error) {
        console.error('SignalR connection error: ', error);
        setTimeout(() => this.startSignalRConnection(), 15000);
      }
    },
    async startCartSignalRConnection() {
      this.connection = new signalR.HubConnectionBuilder()
        .withUrl(`${config.apiSignalR}/cartHub`, {
          accessTokenFactory: () => localStorage.getItem('token'),
          withCredentials: false,
        })
        .build();
      this.connection.on(`CartUpdate-${this.profile.userData.id}`, (update) => {
        console.log('New cartupdate received:', update);
        this.$store.dispatch('getShoppingCart');
      });

      try {
        await this.connection.start();
      } catch (error) {
        console.error('SignalR connection error: ', error);
        setTimeout(() => this.startCartSignalRConnection(), 15000);
      }
    },
    slugify,
  },
};
</script>

<style lang="scss">
.page-wrapper {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.page-wrapper > .main {
  flex: 1 0 auto;
}
</style>
